// import { Theme, createStyles, makeStyles } from '@material-ui/core';
import styled from 'styled-components';

export const ListCheckbox = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  overflow-y: scroll;
  height: 60vh;

  .container {
    min-height: 41vh;
    max-height: 60vh;
    margin-left: 12px;
  }

  .MuiFormControlLabel-root {
    display: flex !important;
    margin-top: 1px;
  }

  .labelOne {
    span {
      font-size: 13px;
      font-weight: bold;
      padding: 2px;
    }
  }

  .labelTwo {
    span {
      font-size: 13px;
      padding: 0 2px;
    }
  }

  .MuiBox-root:first-child {
    margin: 0;
  }
  .MuiBox-root {
    width: 100px;
    height: 20px;
    margin: auto;
  }

  h1 {
    font-size: 1.125rem;
  }
  p {
    font-size: 0.9rem;
  }
`;
